var CurrentUser = require("lib/account/CurrentUser");
var ReactionFeedback = require("components/support/ReactionFeedback");
var HelpSectionLink = require("components/utility/HelpSectionLink");
var Glyphicon = require("components/utility/icons/Glyphicon");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");
var ReactTooltip = require("react-tooltip");

require("writing/evaluations/scoring_data.scss");

class ScoringData extends React.Component {
	constructor(props) {
		super()
		autobind(this)
	}

	showCategoryInfo(markupKey) {
		if (CurrentUser.isPremiumOrTrialAccount()) { 
			this.props.selectMarkup(markupKey);
		}
	}

	activeTags(category) {
		var { leaves, tagging } = this.props;

		if (leaves && tagging) {
			var tagKeys = leaves[this.props.markupKey].tag_keys;
			return _.pick(tagging, tagKeys);
		} else {
			return {};
		}
	}

	// determins color of rubric label
	getLabelColor(label) {
		if (_.includes(AutograderDisplayConfig.SUCCESS_OUTPUT, label)) {
			return 'green'
		} else if (_.includes(AutograderDisplayConfig.MIDDLING_OUTPUT, label)) {
			return 'yellow'
		} else if (_.includes(AutograderDisplayConfig.FAIL_OUTPUT, label)) { 
			return 'red'
		} else {
			return 'black'
		}
	}

	gatherScoreLabels(leaves) {
		if ('final-evaluation' in this.props.evaluating) {
			var answerScore = this.props.evaluating['final-evaluation'].value
		} else {
			var answerScore = 0.0
		}
		var requirement = AutograderDisplayConfig.getScoringDisplayRequirement(answerScore)
		var sorted = _.keys(leaves).sort(function(ka,kb){return leaves[ka].value - leaves[kb].value})
		var labels = {}
		
		_.each(sorted, (key, i) => {
			if ((leaves[key].value)) {
				if (leaves[key].rubric) {
					labels[key] = $wr.capitalize(leaves[key].value)
				} else {
					labels[key] = AutograderDisplayConfig.leafValueToText(leaves[key].value, requirement - i)
				}
			}			
		})
		 return labels
	}

	// renders link to item's edit tab
	renderEditLink(key) {
		return <a key={key} onClick={() => this.props.onModeChange('Edit')}>Select Label</a>
	}

	// renders link to edit tab
	renderEditButton() {
		return (
			<div className='editBtnContainer'>
				<button className='btn btn-primary' onClick={() => this.props.onModeChange('Edit')}>Edit Rubric</button>
			</div>
		)
	}

	renderCategories(categories) {
		var leaves = this.props.leaves;
		if (leaves) {
			var labels = this.gatherScoreLabels(leaves)
			var rows = _.keys(leaves).map((key) => {
				LuckyOrangeClient.tagComponent(`ScoringData: ${key}`);
				
				var scoreLabel = labels[key] ? labels[key] : this.renderEditLink(key)
				var title = AutograderDisplayConfig.getLeafName(key);

				var categoryClassName = ""
				if (this.props.markupKey == key && CurrentUser.isPremiumOrTrialAccount()) {
					categoryClassName += "selectedCategory";
				};

				if (_.includes(AutograderDisplayConfig.NEW_KEYS, key)) {
					var badge = <span className="badge greeen">New!</span>
				} else if (_.includes(AutograderDisplayConfig.BETA_KEYS, key)) {
					var badge = <span className="badge blue">Beta</span>
				}

				const dataTip = AutograderDisplayConfig.getLeafDescription(key);
				return (
					<tr key={key} className={categoryClassName} onClick={ this.showCategoryInfo.bind(this, key)} data-tip={dataTip}>
						<td className="titleCell">
							{ title }
							{ badge }
						</td>
						<td className={`color-${this.getLabelColor(scoreLabel)}`}>
							{ scoreLabel }
						</td>

					</tr>
					
				);
			});	

			return (
				<table className="table table-borderless">
					<tbody>
						{ rows }
					</tbody>
				</table>
			)	
		}
	}

	renderCategoryInfo() {	
		var details = _.map(this.props.tagging, (tags, tagKey) => {
			var title = AutograderDisplayConfig.getTagName(tagKey);
			if (!title) { return; }

			if (this.props.tagColors && (tagKey in this.props.tagColors)) {
				var swatchStyle = { backgroundColor: this.props.tagColors[tagKey] };
				var swatch = (
					<span className="swatch" style={ swatchStyle } />
				);				
			}

			return (
				<p className="tagDetails" key={ tagKey }>
					{ swatch }<span className="descriptionAndCount">
						{ title } ({ tags.length })
					</span>
				</p>
			)
		});

		var descriptionText = AutograderDisplayConfig.getLeafDescription(this.props.markupKey);
		if (descriptionText) {
			var description = (
				<p>
					{ descriptionText }
				</p>
			);
		}


		return (
			<div>
				{ description }
			</div>
		)
	}

	renderScoringFlags() {
		if (CurrentUser.isPremiumOrTrialAccount()) {
			var { filtering, warning } = this.props;

			var shouldDisplay = false

			function renderFlags(keys, className) {
				return keys.map((key) => {
					var title = AutograderDisplayConfig.getFilterOrWarningName(key.key) || key.key;

					return (
						<div key={key}>
							<Glyphicon className={className} icon="flag" /> {title}
						</div>
					)
				});
			}

			if (filtering && _.size(filtering) > 0) {
				var filters = renderFlags(filtering, "filterIcon");
				shouldDisplay = true;
			}
			if (warning && _.size(warning) > 0) {
				var warnings = renderFlags(warning, "warningIcon");
				shouldDisplay = true;
			}
			if (shouldDisplay) {
				return (
					<div className="scoringFlags answerDetailsFlag">
						{filters}
						{warnings}
					</div>
				)
			}
			return undefined;
		}
	}


	render() {
		if (!this.props.leaves || _.size(this.props.leaves) == 0) {
			if (!this.props.leaves || _.size(this.props.leaves) == 0) {
				return (
					<div className="scoringData">
						<div className="categoriesSection">
							{ this.renderScoringFlags() }
						</div>
					</div>
				);

			} else {
				return (
					<div className="scoringData">
						<p className="showToggle">No scoring details available.</p>
					</div>
				);
			}
		}

		return (
			<div className="scoringData">
				<div className="categoriesSection">
					{ this.renderScoringFlags() }
					<div className="scoringCategories">
						{ this.renderCategories() }
						{ this.renderEditButton() }
					</div>
				</div>
				<ReactTooltip effect="solid" />
			</div>
		);
	}
}


ScoringData.propTypes = StrictPropTypes({
	markupKey: PropTypes.string.isRequired,

	leaves: PropTypes.object, // Polarizing after aggregating and filtering
	tagging: PropTypes.object, // Keys limited only to those in markupKey

	filtering: PropTypes.array,
	warning: PropTypes.array,
	evaluating: PropTypes.object, 
	tagColors: PropTypes.object,

	selectMarkup: PropTypes.func.isRequired,
	onModeChange: PropTypes.func
});

module.exports = ScoringData;


// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/ScoringData.js